import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Breadcrumbs, { breadcrumbsClasses } from "@mui/material/Breadcrumbs";
import Container from "@mui/material/Container";
import MuiLink from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import NavigateNextRoundedIcon from "@mui/icons-material/NavigateNextRounded";
import { Link } from "react-router-dom";

const PageContentHeader = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  flexWrap: "wrap",
  marginTop: "10px",
  gap: theme.spacing(2),
}));

const PageHeaderBreadcrumbs = styled(Breadcrumbs)(({ theme }) => ({
  margin: theme.spacing(1, 0),
  [`& .${breadcrumbsClasses.separator}`]: {
    color: (theme.vars || theme).palette.action.disabled,
    margin: 1,
  },
  [`& .${breadcrumbsClasses.ol}`]: {
    alignItems: "center",
  },
}));

const PageHeaderToolbar = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  gap: theme.spacing(1),
  // Ensure the toolbar is always on the right side, even after wrapping
  marginLeft: "auto",
}));

export default function PageContainer(props) {
  const {
    children,
    breadcrumbs,
    title,
    actions = null,
    subtitle,
    titleAdornment,
  } = props;
  return (
    <Container
      maxWidth="xl"
      sx={{ flex: 1, display: "flex", flexDirection: "column" }}
    >
      <Stack sx={{ flex: 1, my: 2 }} spacing={2}>
        <Stack>
          {/* A single crumb just repeats the page title, so only show real trails */}
          {breadcrumbs?.length > 1 && (
            <PageHeaderBreadcrumbs
              aria-label="breadcrumb"
              separator={<NavigateNextRoundedIcon fontSize="small" />}
            >
              {breadcrumbs.map((breadcrumb, index) => {
                return breadcrumb.path ? (
                  <MuiLink
                    key={index}
                    component={Link}
                    underline="hover"
                    color="inherit"
                    to={breadcrumb.path}
                  >
                    {breadcrumb.title}
                  </MuiLink>
                ) : (
                  <Typography
                    key={index}
                    sx={{ color: "text.primary", fontWeight: 600 }}
                  >
                    {breadcrumb.title}
                  </Typography>
                );
              })}
            </PageHeaderBreadcrumbs>
          )}
          <PageContentHeader>
            {subtitle || titleAdornment ? (
              <Box>
                <Stack direction="row" alignItems="center" spacing={1.5}>
                  {title ? (
                    <Typography variant="h5" component="h1">
                      {title}
                    </Typography>
                  ) : null}
                  {titleAdornment}
                </Stack>
                {subtitle ? (
                  <Typography variant="body2" color="text.secondary">
                    {subtitle}
                  </Typography>
                ) : null}
              </Box>
            ) : title ? (
              <Typography variant="h5" component="h1">
                {title}
              </Typography>
            ) : null}
            <PageHeaderToolbar>{actions}</PageHeaderToolbar>
          </PageContentHeader>
        </Stack>
        <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
          {children}
        </Box>
      </Stack>
    </Container>
  );
}
